import DoctorService from "services/DoctorService"
import { APP_PREFIX_PATH } from "configs/AppConfig"
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"

export const initialState = {
  bannedModelOpen: false,
  currentPage: 1,
  deleteModalOpen: false,
  doctor: {},
  doctors: [],
  DrawerInfoIsOpen: false,
  loadedPages: [],
  loadedSearchPages: [],
  loading: false,
  message: "",
  redirect: "",
  searchedDoctors: [],
  searchValue: null,
  selectedDoctor: {},
  showMessage: false,
  totalItems: null,
  totalItemsSearched: null,
  validateModelOpen: false,
}

export const createDoctor = createAsyncThunk(
  "doctor/create",
  async (data, { dispatch, rejectWithValue }) => {
    try {
      const response = await DoctorService.createDoctor(data)
      dispatch(clearStates())
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Error")
    }
  }
)

export const getAllDoctors = createAsyncThunk(
  "doctor/getAll",
  async (page, { dispatch, rejectWithValue }) => {
    try {
      const response = await DoctorService.getAllDoctors(page)
      dispatch(addPage(page))
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)
export const getDoctorById = createAsyncThunk(
  "doctor/getById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DoctorService.getDoctorById(id)
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)
export const searchDoctors = createAsyncThunk(
  "doctor/search",
  async ({ page, value }, { dispatch, getState, rejectWithValue }) => {
    try {
      const response = await DoctorService.getSearchDoctors(value, page)
      dispatch(addSearchPage(page))
      const state = getState()
      const currentPage = state.doctor.currentPage
      if (currentPage === 1) {
        dispatch(clearSearchedDoctor())
      }
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)

export const deleteDoctorById = createAsyncThunk(
  "doctor/delete",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await DoctorService.deleteDoctorById(id)
      dispatch(clearStates())
      dispatch(getAllDoctors(1))
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)

export const updateDoctorById = createAsyncThunk(
  "doctor/update",
  async ({ data, id }, { dispatch, rejectWithValue }) => {
    try {
      const response = await DoctorService.updateDoctorById(id, data)
      dispatch(clearStates())
      return response.data
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)
export const validateDoctorAccount = createAsyncThunk(
  "doctor/validateAccount",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await DoctorService.validateAccount(id)
      dispatch(clearStates())
      dispatch(getAllDoctors(1))
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.message || "Error")
    }
  }
)

export const banDoctorAccount = createAsyncThunk(
  "doctor/banAccount",
  async ({ id, reason }, { dispatch, rejectWithValue }) => {
    try {
      const response = await DoctorService.banAccount(id, reason)
      dispatch(clearStates())
      dispatch(getAllDoctors(1))
      return response
    } catch (error) {
      return rejectWithValue(error.response?.data?.error || "Error")
    }
  }
)

export const doctorSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(createDoctor.pending, (state) => {
        state.loading = true
      })
      .addCase(createDoctor.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = `${APP_PREFIX_PATH}/doctors`
      })
      .addCase(createDoctor.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(getAllDoctors.pending, (state) => {
        state.loading = true
      })
      .addCase(getAllDoctors.fulfilled, (state, action) => {
        state.loading = false
        state.doctors = [...state.doctors, ...action.payload.data]
        state.totalItems = action.payload.totalItems
      })
      .addCase(getAllDoctors.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(getDoctorById.pending, (state) => {
        state.loading = true
      })
      .addCase(getDoctorById.fulfilled, (state, action) => {
        state.loading = false
        state.doctor = action.payload
      })
      .addCase(getDoctorById.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(searchDoctors.pending, (state) => {
        state.loading = true
      })
      .addCase(searchDoctors.fulfilled, (state, action) => {
        state.loading = false
        state.searchedDoctors = [
          ...state.searchedDoctors,
          ...action.payload.data,
        ]
        state.totalItemsSearched = action.payload.totalItems
      })
      .addCase(searchDoctors.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(deleteDoctorById.pending, (state) => {
        state.loading = true
        state.deleteModalOpen = false
      })
      .addCase(deleteDoctorById.fulfilled, (state, action) => {
        state.loading = false
        state.deleteModalOpen = false
      })
      .addCase(deleteDoctorById.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
        state.deleteModalOpen = false
      })
      .addCase(updateDoctorById.pending, (state) => {
        state.loading = true
      })
      .addCase(updateDoctorById.fulfilled, (state, action) => {
        state.loading = false
        state.redirect = `${APP_PREFIX_PATH}/doctors`
      })
      .addCase(updateDoctorById.rejected, (state, action) => {
        state.message = action.payload
        state.showMessage = true
        state.loading = false
      })
      .addCase(validateDoctorAccount.pending, (state) => {
        state.loading = true
      })
      .addCase(validateDoctorAccount.fulfilled, (state, action) => {
        state.loading = false
        state.validateModelOpen = false
      })
      .addCase(validateDoctorAccount.rejected, (state, action) => {
        state.loading = false
        state.message = action.payload
        state.showMessage = true
      })

      .addCase(banDoctorAccount.pending, (state) => {
        state.loading = true
      })
      .addCase(banDoctorAccount.fulfilled, (state, action) => {
        state.loading = false
        state.message = "Doctor account banned successfully"
        state.showMessage = true
        state.bannedModelOpen = false
      })
      .addCase(banDoctorAccount.rejected, (state, action) => {
        state.loading = false
        state.message = action.payload
        state.showMessage = true
      })
  },
  initialState,
  name: "doctor",
  reducers: {
    addPage: (state, action) => {
      state.loadedPages = [...state.loadedPages, action.payload]
    },
    addSearchPage: (state, action) => {
      state.loadedSearchPages = [...state.loadedSearchPages, action.payload]
    },
    clearSearchedDoctor: (state) => {
      state.searchedDoctors = []
    },

    clearSearchedPage: (state) => {
      state.loadedSearchPages = []
    },
    clearStates: (state) => {
      state.doctors = []
      state.currentPage = 1
      state.loadedPages = []
      state.loadedSearchPages = []
      state.totalItems = null
      state.totalItemsSearched = null
      state.searchedDoctors = []
      state.searchValue = null
    },
    closeDeleteModal: (state) => {
      state.deleteModalOpen = false
    },
    hideDoctorMessage: (state) => {
      state.message = ""
      state.showMessage = false
    },
    openDeleteModal: (state) => {
      state.deleteModalOpen = true
    },
    setBanModel: (state, action) => {
      state.bannedModelOpen = action.payload.etat
    },
    setCurrentPage: (state, action) => {
      state.currentPage = action.payload
    },
    setDoctorInfo: (state, action) => {
      state.selectedDoctor = action.payload.doctor
    },
    setDrawerInfo: (state, action) => {
      state.DrawerInfoIsOpen = action.payload.etat
    },
    setRedirect: (state, action) => {
      state.redirect = action.payload
    },
    setSearchValue: (state, action) => {
      state.searchValue = action.payload
    },
    setSelectedDoctor: (state, action) => {
      state.selectedDoctor = action.payload
    },
    setValidateModel: (state, action) => {
      state.validateModelOpen = action.payload.etat
    },
    showDoctorMessage: (state, action) => {
      state.message = action.payload
      state.showMessage = true
      state.loading = false
    },
    showLoading: (state) => {
      state.loading = true
    },
  },
})

export const {
  addPage,
  addSearchPage,
  clearSearchedDoctor,
  clearSearchedPage,
  clearStates,
  closeDeleteModal,
  hideDoctorMessage,
  openDeleteModal,
  setBanModel,
  setCurrentPage,
  setDoctorInfo,
  setDrawerInfo,
  setRedirect,
  setSearchValue,
  setSelectedDoctor,
  setValidateModel,
  showDoctorMessage,
  showLoading,
} = doctorSlice.actions

export default doctorSlice.reducer
